import { useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { useLocalization } from '../../../i18n'
import styles from './navButton.module.css'
import type { INavItem } from '../../../constants/navigationItems'

interface NavButtonProps {
  navItem: INavItem
  onClick?: () => void
}

export function NavButton({ navItem, onClick }: NavButtonProps) {
  const { Icon, labelKey, link } = navItem
  const { t } = useLocalization()
  const label = t(labelKey)

  const getClassName = useMemo(
    () => ({ isActive }: { isActive: boolean }) =>
      isActive ? `${styles.navButton} ${styles.active}` : styles.navButton,
    []
  )

  return (
    <NavLink to={link} onClick={onClick} className={getClassName} aria-label={label}>
      <span className={styles.icon} aria-hidden="true">
        <Icon className={styles.iconSvg} />
      </span>
      <span className={styles.label}>{label}</span>
    </NavLink>
  )
}
